<script>
import InventoryWidget from "@/components/widgets/inventory-widget.vue";

export default {
  page: {
    title: "Inventory",
  },
  components: {
    InventoryWidget,
  },
};
</script>

<template>
  <InventoryWidget viewFrom="supply" />
</template>
